// Persists the CGTrader AI browser-push toggle client-side. Push opt-in is a property of the
// browser's CleverPush subscription, so it is deliberately per-device and has no server record.
// The email toggle is NOT stored here: it lives in User#email_settings and is read from page
// config. Best-effort; storage may be unavailable (private mode, quota).

export const NOTIFICATION_PREFERENCES_KEY = 'ai_studio_notification_preferences'
export const NOTIFICATIONS_POPOVER_SEEN_KEY = 'ai_studio_notifications_popover_seen'

export const readBrowserNotifications = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(NOTIFICATION_PREFERENCES_KEY))
    if (!stored || typeof stored !== 'object') return false

    return Boolean(stored.browserNotifications)
  } catch (_) {
    return false
  }
}

export const writeBrowserNotifications = (enabled) => {
  try {
    window.localStorage.setItem(NOTIFICATION_PREFERENCES_KEY, JSON.stringify({
      browserNotifications: Boolean(enabled),
    }))
  } catch (_) {
    // No-op.
  }
}

export const hasSeenNotificationsPopover = () => {
  try {
    return window.localStorage.getItem(NOTIFICATIONS_POPOVER_SEEN_KEY) === 'true'
  } catch (_) {
    return true
  }
}

export const markNotificationsPopoverSeen = () => {
  try {
    window.localStorage.setItem(NOTIFICATIONS_POPOVER_SEEN_KEY, 'true')
  } catch (_) {
    // No-op.
  }
}
